import React from 'react';

import { CloseModal } from 'common/module/ui/lazy-modal';
import { EDIT_PROFILE_CARD_MODAL } from 'common/module/ui/lazy-modal/constant-types';
import buildReactDomModalModule from 'common/module/ui/lazy-modal/react-dom-modal-module';
import trans from 'common/tools/translations/trans';

import { openProfileCardPickerModal } from 'website/services/modal';

import SectionModal, { SectionModalSection } from './SectionModal';

type EditProfileCardModalParams = {
  avatarImageUrl?: string;
  backgroundImageUrl?: string;
};

const EditProfileCardModal = ({
  closeModal,
  params
}: {
  closeModal: CloseModal;
  params: EditProfileCardModalParams | null | undefined;
}) => {
  const { avatarImageUrl, backgroundImageUrl } = params ?? {};

  const handleAvatarModify = () => {
    openProfileCardPickerModal({
      mode: 'avatar',
      categories: [],
      items: []
    });
  };

  const handleBackgroundModify = () => {
    openProfileCardPickerModal({
      mode: 'background',
      categories: [],
      items: []
    });
  };

  const sections: SectionModalSection[] = [
    {
      id: 'avatar',
      label: trans('userprofile.edit-card.modal.avatar'),
      imageUrl: avatarImageUrl,
      imageAlt: trans('userprofile.edit-card.modal.avatar'),
      shape: 'circle',
      actionLabel: trans('userprofile.edit-card.modal.modify'),
      onActionClick: handleAvatarModify
    },
    {
      id: 'background',
      label: trans('userprofile.edit-card.modal.background'),
      imageUrl: backgroundImageUrl,
      imageAlt: trans('userprofile.edit-card.modal.background'),
      actionLabel: trans('userprofile.edit-card.modal.modify'),
      onActionClick: handleBackgroundModify
    }
  ];

  return (
    <SectionModal
      title={trans('userprofile.user-cover.edit-card.label')}
      sections={sections}
      onCancel={closeModal}
      cancelLabel={trans('common.finish')}
      size="medium"
    />
  );
};

export default buildReactDomModalModule<
  EditProfileCardModalParams | null | undefined
>(EDIT_PROFILE_CARD_MODAL, (params, closeModal) => (
  <EditProfileCardModal closeModal={closeModal} params={params} />
));
